import React from 'react';

import AboutSection from '../components/AboutSection';
import HeroSection from '../components/HeroSection';
import ServicesSection from '../components/ServicesSection';
import ProjectSection from '../components/ProejectSection';
import TestimonialSection from '../components/TestimonialSection';
import ContactBanner from '../components/ContactBanner';

import CP from '../components/CP';

export default function Home() {
  return (
    <div>
      <HeroSection />
      <AboutSection />
      <TestimonialSection />
      <ServicesSection />
      <CP />
      <ProjectSection />
      <ContactBanner />
    </div>
  );
}
